import { Link } from 'react-router-dom';
import { MyGamesList } from '../components/MyGamesList';
import { ResultsList } from '../components/ResultsList';

/** Every game this browser created or hosted, and every result it played to: no limits. */
export function Games() {
  return (
    <div className="centered">
      <div className="col" style={{ width: 'min(38rem, 100%)', gap: '0.75rem' }}>
        <div className="card col" style={{ width: '100%' }}>
          <h1>My games</h1>
          <p className="muted" style={{ marginTop: 0 }}>
            Everything you've forged, hosted or played on this device.
          </p>
          <MyGamesList />
          <ResultsList />
        </div>
        <Link className="btn btn-ghost" to="/">
          ← Back
        </Link>
      </div>
    </div>
  );
}
